import { render, staticRenderFns } from "./ListClass.vue?vue&type=template&id=1f13b613"
import script from "./ListClass.vue?vue&type=script&lang=js"
export * from "./ListClass.vue?vue&type=script&lang=js"
import style0 from "./ListClass.vue?vue&type=style&index=0&id=1f13b613&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports